import {
  Profile,
  ProfileLineItem,
  ProfileStatus,
  ProfileType,
} from "@interfaces/profile";

export const decodeProfile = (profile: Profile): ProfileLineItem => {
  return {
    id: profile.profile_id,
    organisationId: profile.organisation_id,
    name: profile.name,
    email: profile.email,
    emailNotifications: profile.email_notifications,
    created: new Date(profile.created),
    status: decodeProfileStatus(profile.status),
    type: decodeProfileType(profile.type),
  };
};

export const encodeProfile = (profile: ProfileLineItem): Profile => {
  return {
    profile_id: profile.id,
    organisation_id: profile.organisationId,
    name: profile.name,
    email: profile.email,
    email_notifications: profile.emailNotifications,
    created: new Date(profile.created),
    status: encodeProfileStatus(profile.status),
    type: encodeProfileType(profile.type),
  };
};

const decodeProfileStatus = (profileStatus: string): ProfileStatus => {
  switch (profileStatus) {
    default:
    case "profile-status_active":
      return ProfileStatus.Active;
    case "profile-status_invited":
      return ProfileStatus.Invited;
  }
};

const encodeProfileStatus = (profileStatus: ProfileStatus): string => {
  switch (profileStatus) {
    case ProfileStatus.Active:
      return "profile-status_active";
    case ProfileStatus.Invited:
      return "profile-status_invited";
  }
};

const decodeProfileType = (profileType: string): ProfileType => {
  switch (profileType) {
    default:
    case "profile-type_standard":
      return ProfileType.Standard;
    case "profile-type_admin":
      return ProfileType.Admin;
  }
};

const encodeProfileType = (profileType: ProfileType): string => {
  switch (profileType) {
    case ProfileType.Admin:
      return "profile-type_admin";
    case ProfileType.Standard:
      return "profile-type_standard";
  }
};
